import PageNavigationComponent from './PageNavigation';

const PageNavigation = PageNavigationComponent;

export default PageNavigation;
